import { CheckoutFlow, setPaymentAttempt } from '@src/telemetry/checkout-attempts'
import { buildCheckoutErrorContext } from '@src/telemetry/checkout-error.helper'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

export type UnifiedPaymentGateway = 'STRIPE' | 'PAYPAL' | 'AMAZON' | 'BRAINTREE'

export const trackUnifiedPayButtonClick = ({
  flow,
  paymentMethod,
  errorReason,
}: {
  flow: CheckoutFlow
  paymentMethod: string
  errorReason?: string
}) => {
  trackEvent(TELEMETRY_EVENT_NAMES.UNIFIED_PAY_BUTTON_CLICK, {
    flow,
    paymentMethod,
    errorReason,
  })
}

export const trackUnifiedPaymentInitiated = ({ paymentGateway }: { paymentGateway: UnifiedPaymentGateway }) => {
  trackEvent(TELEMETRY_EVENT_NAMES.UNIFIED_PAYMENT_INITIATED, {
    paymentGateway,
  })
}

export const trackUnifiedPaymentAuthorised = () => {
  trackEvent(TELEMETRY_EVENT_NAMES.UNIFIED_PAYMENT_AUTHORISED, {})
}

export const trackCheckoutErrorLog = ({
  errorReason,
  error,
  stage,
  apiName,
}: {
  errorReason?: string
  error?: unknown
  stage?: string
  apiName?: string
} = {}) => {
  const context = buildCheckoutErrorContext(error, { stage, apiName, errorReason })
  trackEvent(TELEMETRY_EVENT_NAMES.CHECKOUT_ERROR_LOG_WEB_CHECKOUT, {
    errorReason: context.error_reason,
    errorType: context.error_type,
    errorStage: context.error_stage,
    errorOrigin: context.error_origin,
    errorMessage: context.error_message,
    httpStatus: context.http_status,
    errorCode: context.error_code,
    apiEndpoint: context.api_endpoint,
  })
}

export const initializeUnifiedPayButtonClick = ({
  flow,
  paymentMethod,
  paymentGateway,
}: {
  flow: CheckoutFlow
  paymentMethod: string
  paymentGateway?: UnifiedPaymentGateway
}) => {
  setPaymentAttempt({
    flow,
    payment_method: paymentMethod,
    payment_gateway: paymentGateway,
  })
  trackUnifiedPayButtonClick({ flow, paymentMethod })
}
